import { Check } from '@mui/icons-material';
import { Alert, Box, Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import { IMaterial } from '../../interfaces';
import { ImportFormSection } from './ImportFormSection';


export interface IMaterialImportDialog {
    onImported: (materials: IMaterial[], warnings?: string[]) => void
}

export const MaterialImportDialog: React.SFC<IMaterialImportDialog> = ({ onImported }) => {

    const onOpen = () => {
        setComplete(undefined);
        setWarnings([]);
        setOpen(true);
    }

    const onClose = () => {

        if (complete)
            onImported(complete);

        setOpen(false);
    }

    const handleImportComplete = (materials: IMaterial[], importWarnings?: string[]) => {
        setComplete(materials);
        setWarnings(importWarnings ?? []);
    }

    const [open, setOpen] = useState(false);
    const [complete, setComplete] = useState<IMaterial[]>();
    const [warnings, setWarnings] = useState<string[]>([]);

    return (
        <span>
            <Tooltip title="Import Materials">


                <Button sx={{ mb: 1, mr: 1 }} variant="outlined" size="small" color="info" onClick={onOpen} >Import</Button>

            </Tooltip>

            <Dialog
                open={open}
                onClose={onClose}
                fullWidth
            >
                <DialogTitle>
                    Material Import
                </DialogTitle>
                <DialogContent>

                    {complete ?
                        <>
                            <p><Check /> Import complete. {complete.length} materials were updated.</p>
                            {warnings.length > 0 &&
                                <Alert severity="warning" sx={{ mt: 2 }}>
                                    <strong>Quantity was not updated for one or more uploaded rows.</strong>
                                    {warnings.map((warning, index) => (
                                        <Box key={index} sx={{ mt: 1 }}>{warning}</Box>
                                    ))}
                                </Alert>
                            }
                        </>
                        :
                        <>
                            <p>Select a csv to upload. The import will begin automatically.</p>

                            <ImportFormSection
                                onImported={handleImportComplete}
                            />
                        </>

                    }



                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </span>
    );
}
